export const ReportStatus = {
  queued: { value: 'queued', name: 'Oczekuje w kolejce' },
  fetchingData: { value: 'fetchingData', name: 'Generowanie' },
  rendering: { value: 'rendering', name: 'Generowanie' },
  ready: { value: 'ready', name: 'Gotowy' },
  failed: { value: 'failed', name: 'Błąd' },
};
